'use client';

import { useEffect, useState } from 'react';
import { useStore } from 'zustand';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { ProfileSheet } from './header-profile.sheet.component';

import { Button } from '@/components/ui/button/button.component';
import { authStore } from '@/store/auth.store';
import { modalsOpeningStore, setOpenSignInModal } from '@/store/modal';
import { LoginOriginEnum } from '@/types/enums/analytics/login/login-analytics.enum';
import { SignInModal } from '@/app/(main)/_components/sign-in-modal/sign-in-modal.component';
import { useLevelTwoContext } from '@/feature-flags/providers/LevelTwoProvider';
import { logInfo } from '@/feature-flags/utils/logger';
import { getCorrelationContext } from '@/feature-flags/utils/correlation';

export function NavbarProfile() {
  const [mounted, setMounted] = useState(false);
  const isLoggedIn = useStore(authStore, (state) => state.computed.isLoggedIn);
  const userId = useStore(authStore, (state) => state.authenticatedUser?.id);
  const openSignInModal = useStore(
    modalsOpeningStore,
    (state) => state.signInModalIsOpen,
  );
  const signInModalInitialStep = useStore(
    modalsOpeningStore,
    (state) => state.signInModalInitialStep,
  );
  const { config, variant } = useLevelTwoContext();

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted) {
      return;
    }

    const loginEnabled = config.newLogin;
    const buttonVisible = !isLoggedIn && loginEnabled;

    logInfo('Login feature evaluated', {
      event: 'login_feature_evaluated',
      ...getCorrelationContext(),
      userId,
      loginEnabled,
      isLoggedIn,
      buttonVisible,
      variant,
      source: 'NavbarProfile',
    });
  }, [mounted, config.newLogin, isLoggedIn, userId, variant]);

  const handleSignIn = () => {
    setOpenSignInModal(true, { origin: LoginOriginEnum.HEADER });
  };

  if (!mounted) {
    return null;
  }

  const showLoginButton = !isLoggedIn && config.newLogin;
  const showProfileSheet = isLoggedIn && config.newLogin;

  return (
    <>
      {!isLoggedIn
        ? (
            <>
              {showLoginButton && (
                <Button
                  data-testid={DataTestIdEnum.LOGIN_BUTTON}
                  variant="secondary"
                  color="primary"
                  className="text-sm md:text-base h-8"
                  onClick={handleSignIn}
                >
                  Entrar
                </Button>
              )}
              <SignInModal
                isOpen={openSignInModal}
                setIsOpen={() => setOpenSignInModal(false)}
                initialStep={signInModalInitialStep}
              />
            </>
          )
        : (
            <>
              {showProfileSheet && <ProfileSheet />}
            </>
          )}
    </>
  );
}
